// /src/App.jsx
import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import Home from './pages/Home'
import PlantWiki from './pages/PlantWiki'
import Reforestation from './pages/Reforestation'
import SeedBank from './pages/SeedBank'
import PlantDetail from './pages/PlantDetail'

import AdminMinimalist from './pages/AdminMinimalist'
import AdminLogin from './pages/AdminLogin'
import ProtectedRoute from './components/ProtectedRoute'
import { AuthProvider } from './utils/authContext'
import Test from './pages/Test'

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Admin routes without header/footer */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route 
          path="/admin" 
          element={
            <ProtectedRoute>
              <AdminMinimalist />
            </ProtectedRoute>
          } 
        />
        <Route path="/test" element={<Test />} />
        
        {/* Public routes with header/footer */}
        <Route path="/" element={
          <div className="min-h-screen flex flex-col">
            <Header />
            <main className="flex-1">
              <Home />
            </main>
            <Footer />
          </div>
        } />
        
        <Route path="/wiki" element={
          <div className="min-h-screen flex flex-col">
            <Header />
            <main className="flex-1">
              <PlantWiki />
            </main>
            <Footer />
          </div>
        } />
        
        <Route path="/reforestation" element={
          <div className="min-h-screen flex flex-col">
            <Header />
            <main className="flex-1">
              <Reforestation />
            </main>
            <Footer />
          </div>
        } />
        
        <Route path="/seedbank" element={
          <div className="min-h-screen flex flex-col">
            <Header />
            <main className="flex-1">
              <SeedBank />
            </main>
            <Footer />
          </div>
        } />
        
        <Route path="/plant/:id" element={
          <div className="min-h-screen flex flex-col">
            <Header />
            <main className="flex-1">
              <PlantDetail />
            </main>
            <Footer />
          </div>
        } />
        

      </Routes>
    </AuthProvider>
  )
}

export default App 